import axios from "axios";
import cookieManager from "./CookieManager";
import {GATEWAY_URL} from "../env";
import Constants from "./Constants";

class LoginHelper {
  static async LoginWithUserAndPassword(username, password) {
    try {
      const postData = { username: username, password: password };
      const response = await axios.post(
        GATEWAY_URL + "/AuthService/Login",
        postData
      );
      const { accessToken, refreshToken } = response.data.tokenData;
      const { skillsID } = response.data;

      cookieManager.set(Constants.ACCESS_TOKEN, accessToken);
      cookieManager.set(Constants.REFRESH_TOKEN, refreshToken);
      cookieManager.set(Constants.SKILLS_ID, skillsID);

      return response.data;
    } catch (error) {
      console.error("Error refreshing the token:", error);
      throw error;
    }
  }

  static async LoginWithExchangeCode(code) {
    try {
      const response = await axios.post(
        GATEWAY_URL + "/AuthService/RedeemExchangeCode",
        { Code: code }
      );

      if (!response.data?.status) {
        throw new Error(response.data?.errorMessage || "Exchange code redeem failed");
      }

      const { accessToken, refreshToken } = response.data.tokenData;
      const responseSkillsID = response.data.skillsID;

      // Drop any prior identity before writing the new one to avoid stale
      // cookies surviving an account switch.
      cookieManager.remove(Constants.ACCESS_TOKEN);
      cookieManager.remove(Constants.REFRESH_TOKEN);
      cookieManager.remove(Constants.SKILLS_ID);

      cookieManager.set(Constants.ACCESS_TOKEN, accessToken);
      cookieManager.set(Constants.REFRESH_TOKEN, refreshToken);
      if (responseSkillsID) {
        cookieManager.set(Constants.SKILLS_ID, responseSkillsID);
      }

      console.log("Exchange code redeemed.");
      return response.data;
    } catch (error) {
      console.error("Error redeeming exchange code:", error);
      throw error;
    }
  }

  static async LoginWithRefreshToken(token, skillsID = "") {
    try {
      const response = await axios.post(
        GATEWAY_URL + "/AuthService/LoginWithRefreshToken",
        {
          RefreshToken: token,
          SkillsID: skillsID,
        }
      );

      const { accessToken, refreshToken } = response.data.tokenData;
      const responseSkillsID = response.data.skillsID;

      cookieManager.set(Constants.ACCESS_TOKEN, accessToken);
      cookieManager.set(Constants.REFRESH_TOKEN, refreshToken);
      if (responseSkillsID) {
        cookieManager.set(Constants.SKILLS_ID, responseSkillsID);
      }

      console.log("Token refreshed.");
      return response.data;
    } catch (error) {
      console.error("Error refreshing the token:", error);
      throw error;
    }
  }
}

export default LoginHelper;
